import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL || "http://localhost:8000/api/";

const filenameFromDisposition = (disposition, invoiceId) => {
  const match = String(disposition || "").match(/filename="?([^";]+)"?/i);
  return match?.[1] || `RD-Link-Invoice-${invoiceId}.pdf`;
};

export const downloadSubscriptionInvoice = async (invoiceId) => {
  if (!invoiceId || !String(invoiceId).startsWith("in_")) return false;

  try {
    const response = await axios.get(
      `${API_URL}brand/subscription-invoices/${encodeURIComponent(invoiceId)}/download`,
      {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_USERTOKEN)}`,
        },
        responseType: "blob",
      }
    );
    const blob = new Blob([response.data], { type: "application/pdf" });
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filenameFromDisposition(
      response.headers?.["content-disposition"],
      invoiceId
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);

    return true;
  } catch (error) {
    return false;
  }
};
